import SportPositionTypesList from "./SportPositionTypesList";
export default SportPositionTypesList;
